import React, { useEffect, useState } from 'react';
import { apiCall } from '../utils/apiService';

const SettingLayer = () => {
    const [alertMessage, setAlertMessage] = useState('');
    const [spinner, setSpinner] = useState(false);
    const [user, setUser] = useState();
    const [setting, setSetting] = useState({
        isAddQueueLog: false,
        allowedDuplicate: false,
    });

    const fetchSettingData = async () => {
        try {
            const user = JSON.parse(localStorage.getItem('user'))
            setUser(user)
            setSetting({
                isAddQueueLog: user.isAddQueueLog,
                allowedDuplicate: user.allowedDuplicate
            })
        } catch (error) {
            console.error('Error fetching dashboard:', error);
        }
    };

    const handleSettingSubmit = async () => {
        setSpinner(true);
        try {
            const response = await apiCall({
                url: 'user/update-profile',
                method: 'POST',
                body: setting
            });

            localStorage.setItem("user", JSON.stringify({ ...user, ...setting }));

            setAlertMessage({ message: response.msg, class: 'success' });

            if (response.success) {
                hideAlert(2)
            }

        } catch (error) {
            setAlertMessage({ message: error.message, class: 'danger' });
            hideAlert(2);
        }
    };

    // hide alert after few seconds
    const hideAlert = (sec = 1) => {
        setTimeout(() => {
            setAlertMessage('');
            setSpinner(false);
        }, (sec * 1000));
    }

    useEffect(() => {
        if (setting !== undefined) {
            handleSettingSubmit();
        }
    }, [setting]);

    useEffect(() => {
        document.title = "Settings"
        fetchSettingData();
    }, [])
    return (
        <>
            <div className="card">
                <div className="card-header">
                    <div className="card-title">
                        Your App Settings
                    </div>
                </div>
                <div className="card-body">
                    <div className='py-3'>
                        <div className="d-flex align-items-center justify-content-between">
                            <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="switch1"
                            >
                                Do you want to use queue system in your app?
                            </label>
                            <div className="form-switch switch-success d-flex align-items-center gap-3 my-3">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="switch1"
                                    style={{ width: '60px', height: '25px' }}
                                    checked={!!setting.isAddQueueLog} // ensure it's boolean
                                    onChange={(e) => {
                                        setSetting({ ...setting, isAddQueueLog: e.target.checked });
                                    }}
                                />
                            </div>

                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                            <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="switch2"
                            >
                                Do you want to allow duplicate messages in your app?
                            </label>
                            <div className="form-switch switch-success d-flex align-items-center gap-3 my-3">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="switch2"
                                    style={{ width: '60px', height: '25px' }}
                                    checked={!!setting.allowedDuplicate} // ensure it's boolean
                                    onChange={(e) => {
                                        setSetting({ ...setting, allowedDuplicate: e.target.checked });
                                    }}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>


    )
}

export default SettingLayer